import React, {useEffect, useState} from 'react';
import {Button, Input, Table, Tag, Popconfirm, Typography, message, Switch, Modal} from 'antd';
import {useAuth} from "../../contexts/AuthContext";
import {useWindowDimensions} from "../../contexts/WindowDimensionsContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faPen, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, CheckOutlined} from "@ant-design/icons";
import axios from "axios";
import PageTitle from "../../components/PageTitle";
const { Search } = Input;

export default function Manage({ backendApiUrl }) {
    const authContext = useAuth();
    const windowDimensions = useWindowDimensions();
    const [users, setUsers] = useState([]);
    const [displayedUsers, setDisplayedUsers] = useState([]);
    const [displayedNewUsers, setDisplayedNewUsers] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [elementId, setElementId] = useState(null);
    const [isNewUser, setIsNewUser] = useState(false);
    const [newElement, setNewElement] = useState({_id: "", firstName: "", lastName: "", email: "", password: "defaultPassword", userValidated: true, isEmailValid: false, isAdmin: false, isSuperAdmin: false});

    const ValidateButton = ({ record }) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
            <Button
                icon={<CheckOutlined style={{ color: "green" }} />}
                onClick={() => {
                    setIsOpen(true);
                    record.userValidated = true;
                    setNewElement(record);
                    setElementId(record._id);
                    setIsNewUser(true)
                }}
                style={{
                    borderColor: isHovered ? "#77b97a": "green",
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            />
        );
    };

    const columnsNewUsers = [
        {
            title: "Prénom",
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: "Nom",
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: "Email",
            dataIndex: 'email',
            key: 'email',
            width: '350px',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <div className={"flex gap-2"}>
                    <Popconfirm
                        title="Supprimer l'utilisateur"
                        description="Êtes vous sur de vouloir le supprimer ?"
                        okText="Oui"
                        cancelText="Non"
                        onConfirm={() => handleElementDelete(record._id ? record._id : "")}
                    >
                        <Button icon={<FontAwesomeIcon icon={faTrash} />} danger />
                    </Popconfirm>
                    <ValidateButton record={record}/>
                </div>
            ),
            width: 200,
        },
    ];

    const columns = [
        {
            title: "Prénom",
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: "Nom",
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: "Email",
            dataIndex: 'email',
            key: 'email',
            width: '350px',
        },
        {
            title: "Email validé",
            dataIndex: 'isEmailValid',
            key: 'isEmailValid',
            render: (isEmailValid) => (
                <Tag color={isEmailValid ? "green" : "red"}>{isEmailValid ? "Oui" : "Non"}</Tag>
            ),
        },
        {
            title: "Admin",
            dataIndex: 'isAdmin',
            key: 'isAdmin',
            render: (isAdmin) => (
                <Tag color={isAdmin ? "green" : "red"}>{isAdmin ? "Oui" : "Non"}</Tag>
            ),
        },
        {
            title: "Super Admin",
            dataIndex: 'isSuperAdmin',
            key: 'isSuperAdmin',
            render: (isSuperAdmin) => (
                <Tag color={isSuperAdmin ? "green" : "red"}>{isSuperAdmin ? "Oui" : "Non"}</Tag>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <div className={"flex gap-2"}>
                    <Popconfirm
                        title="Supprimer l'utilisateur"
                        description="Êtes vous sur de vouloir le supprimer ?"
                        okText="Oui"
                        cancelText="Non"
                        onConfirm={() => handleElementDelete(record._id ? record._id : "")}
                    >
                        <Button icon={<FontAwesomeIcon icon={faTrash} />} danger />
                    </Popconfirm>
                    <Button icon={<FontAwesomeIcon icon={faPen} />} onClick={() => { setIsOpen(true); setNewElement(record); setElementId(record._id) }} />
                    <Button icon={<FontAwesomeIcon icon={faEye} />} onClick={() => { setIsOpen(true); setNewElement(record); setElementId("view")}} />
                </div>
            ),
            width: 200,
        },
    ];

    useEffect(() => {
        fetchElements();
    }, []);

    const fetchElements = async () => {
        try {
            const response = await axios.get(`${backendApiUrl}/user/`);
            if (response.status === 200 && response.data.data.length > 0) {
                const currentUser = authContext.currentUser;

                let filteredUsers = [];

                if (currentUser?.email === 'forster.frederic@gmail.com') {
                    filteredUsers = response.data.data;
                } else {
                    filteredUsers = response.data.data.filter(user => user.email !== 'forster.frederic@gmail.com');
                }

                const sortedUsers = filteredUsers.sort((a, b) => a.firstName.localeCompare(b.firstName));

                setUsers(sortedUsers);
                setDisplayedNewUsers(sortedUsers.filter(user => !user.userValidated));
                setDisplayedUsers(sortedUsers.filter(user => user.userValidated));
            } else if (response.status === 404) {
                setUsers([]);
                setDisplayedUsers([]);
            }
        } catch (error) {
            setUsers([]);
            setDisplayedUsers([]);
            console.error('Error fetching users:', error);
        }
    };

    const handleSendVerifyEmail = async () => {
        try {
            const response = await axios.post(`${backendApiUrl}/user/send-verify-email/${newElement.email}`);
            if (response.status === 200)
                message.success("Un email de réinitialisation de mot de passe à été envoyé à '" + newElement.email + "'.")
            else
                message.error("Une erreur s'est produite lors de l'envoi de l'email de réinitialisation de mot de passe.")
        } catch (error) {
            console.error("Error sending password reset email:", error);
        }
    }

    const handleElementSubmit = async (event) => {
        event?.preventDefault();

        try {
            if (elementId) {
                await axios.put(`${backendApiUrl}/user/id/${elementId}`, newElement, {
                    headers: { "Content-Type": "application/json" },
                });
            } else {
                await axios.post(`${backendApiUrl}/user/`, newElement, {
                    headers: { "Content-Type": "application/json" },
                });
            }
            setIsOpen(false)
            resetForm();
            fetchElements()
        } catch (error) {
            console.error("Error submitting user:", error);
        }
    };

    const handleElementDelete = async (id) => {
        try {
            await axios.delete(`${backendApiUrl}/user/id/${id ? id : elementId}`);
            setIsOpen(false)
            resetForm();
            fetchElements()
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    }

    const handleMultipleElementDelete = async (selectedKeys) => {
        try {
            selectedKeys.selectedRowKeys.map((id) =>
                handleElementDelete(id)
            )
            setSelectedRowKeys([]);
            fetchElements();
        } catch (error) {
            console.error("Error deleting users:", error);
            message.error("An error occurred while deleting users.");
        }
    };

    const resetForm = () => {
        setElementId(null);
        setNewElement({
            _id: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "defaultPassword",
            userValidated: true,
            isEmailValid: false,
            isAdmin: false,
            isSuperAdmin: false,
        });
        setIsNewUser(false)
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
    };

    const handleSearch = (value) => {
        const searchValue = value.toLowerCase();
        if (searchValue) {
            const filteredUsers = users.filter(user =>
                Object.values(user).some(val =>
                    String(val).toLowerCase().includes(searchValue)
                )
            );
            setDisplayedNewUsers(filteredUsers.filter(user => !user.userValidated));
            setDisplayedUsers(filteredUsers.filter(user => user.userValidated));
        } else {
            setDisplayedNewUsers(users
                .filter(user => !user.userValidated)
                .sort((a, b) => a.firstName.localeCompare(b.firstName)));

            setDisplayedUsers(users
                .filter(user => user.userValidated)
                .sort((a, b) => a.firstName.localeCompare(b.firstName)));
        }
    };

    return (
        <div className={"mb-auto"}>
            <div style={{ marginBottom: "30px", width: "100%" }}>
                <div className={"w-100 flex justify-between gap-2 flex-wrap"}>
                    <div className={"flex gap-5 flex-wrap flex-center"}>
                        <PageTitle title={"Gestion"}></PageTitle>
                        {authContext.currentUser?.isSuperAdmin && (
                            <Button type={"primary"} icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setIsOpen(true)}>
                                Ajouter un utilisateur
                            </Button>
                        )}
                        {selectedRowKeys.length > 0 && (
                            <Popconfirm
                                title="Supprimer les utilisateurs"
                                description="Êtes vous sur de vouloir les supprimer ?"
                                okText="Oui"
                                cancelText="Non"
                                onConfirm={() => {handleMultipleElementDelete(rowSelection); setSelectedRowKeys([])}}
                            >
                                <Button
                                    icon={<FontAwesomeIcon icon={faTrash} />}
                                    danger
                                >
                                    Supprimer les éléments sélectionnés
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                    <div className={"flex gap-2 flex-wrap flex-center"}>
                        <Search placeholder="Recherche" onSearch={handleSearch} allowClear enterButton style={{ width: 250 }}/>
                    </div>
                </div>
            </div>

            <p className={"font-bold text-xl mb-3"}>Nouveaux utilisateurs:</p>
            <Table
                rowKey="_id"
                rowSelection={rowSelection}
                columns={columnsNewUsers}
                dataSource={displayedNewUsers}
                pagination={{ pageSize: 30 }}
                size="middle"
                scroll={{ x: windowDimensions.windowWidth < 900 ? 800 : undefined }}
            />

            <p className={"font-bold text-xl mb-3 mt-6"}>Utilisateurs confirmés:</p>
            <Table
                rowKey="_id"
                rowSelection={rowSelection}
                columns={columns}
                dataSource={displayedUsers}
                pagination={{ pageSize: 30 }}
                size="middle"
                scroll={{ x: windowDimensions.windowWidth < 900 ? 800 : undefined }}
            />

            {isOpen && (
                <Modal
                    open={isOpen}
                    onCancel={() => { setIsOpen(false); resetForm(); }}
                    footer={null}
                    width="90%"
                    maxWidth={1100}
                    minWidth={300}
                    maxHeight="95vh"
                    centered
                    className="modal-custom"
                >
                    <div className="modal-content">
                        <div className="modal-header font-bold text-2xl mt-3 mb-5 mx-auto">
                            {elementId ? elementId === "view" ? "UTILISATEUR" : isNewUser ? "VALIDER L'UTILISATEUR" : "MODIFIER UN UTILISATEUR" : "CRÉER UN UTILISATEUR"}
                        </div>
                        <form onSubmit={handleElementSubmit}>
                            <div className="modal-body px-2 flex flex-col gap-2">
                                <div className="w-full">
                                    <span className="block text-gray-500 font-medium mb-1">Prénom <span className={"text-custom-blue"}>{elementId !== "view" ? "*" : ""}</span></span>
                                    {elementId !== "view" && <Input type="text" placeholder="Prénom" value={newElement.firstName} onChange={(e) => setNewElement({ ...newElement, firstName: e.target.value })} className="w-full rounded-lg" style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}/>}
                                    {elementId === "view" && <Typography.Text>{newElement.firstName}</Typography.Text>}
                                </div>
                                <div className="w-full">
                                    <span className="block text-gray-500 font-medium mb-1">Nom <span className={"text-custom-blue"}>{elementId !== "view" ? "*" : ""}</span></span>
                                    {elementId !== "view" && <Input type="text" placeholder="Nom" value={newElement.lastName} onChange={(e) => setNewElement({ ...newElement, lastName: e.target.value })} className="w-full rounded-lg" style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}/>}
                                    {elementId === "view" && <Typography.Text>{newElement.lastName}</Typography.Text>}
                                </div>
                                <div className="w-full">
                                    <span className="block text-gray-500 font-medium mb-1">Email <span className={"text-custom-blue"}>{elementId !== "view" ? "*" : ""}</span></span>
                                    {elementId !== "view" && <Input type="text" placeholder="Email" value={newElement.email} onChange={(e) => setNewElement({ ...newElement, email: e.target.value })} className="w-full rounded-lg" style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}/>}
                                    {elementId === "view" && <Typography.Text>{newElement.email}</Typography.Text>}
                                </div>
                                <div className="w-full mt-2">
                                    <span className="block text-gray-500 font-medium mb-1">Administrateur <span className={"text-custom-blue"}>{elementId !== "view" ? "*" : ""}</span></span>
                                    {elementId !== "view" &&
                                        <div className={"flex gap-4"}>
                                            <Typography.Text>L'utilisateur peut-il modifier des éléments ?</Typography.Text>
                                            <Switch checkedChildren="Oui" unCheckedChildren="Non" className={"min-w-14 ml-auto"} onChange={(e) => setNewElement({ ...newElement, isAdmin: e})} checked={newElement.isAdmin}/>
                                        </div>
                                    }
                                    {elementId === "view" &&
                                        <div className={"flex gap-4"}>
                                            <Typography.Text>L'utilisateur peut-il modifier des éléments ?</Typography.Text>
                                            <Tag color={newElement.isAdmin ? "green" : "red"} className={"h-max-content ml-auto"}>{newElement.isAdmin ? "Oui" : "Non"}</Tag>
                                        </div>
                                    }
                                </div>
                                <div className="w-full">
                                    <span className="block text-gray-500 font-medium mb-1">Super Administrateur <span className={"text-custom-blue"}>{elementId !== "view" ? "*" : ""}</span></span>
                                    {elementId !== "view" &&
                                        <div className={"flex gap-4"}>
                                            <Typography.Text disabled={!newElement.isAdmin}>L'utilisateur peut-il modifier des éléments dans l'onglet "Gestion" ?</Typography.Text>
                                            <Switch disabled={!newElement.isAdmin} checkedChildren="Oui" unCheckedChildren="Non" className={"min-w-14 ml-auto"} onChange={(e) => setNewElement({ ...newElement, isSuperAdmin: e})} checked={newElement.isSuperAdmin}/>
                                        </div>
                                    }
                                    {elementId === "view" &&
                                        <div className={"flex gap-4"}>
                                            <Typography.Text>L'utilisateur peut-il modifier des éléments dans l'onglet "Gestion" ?</Typography.Text>
                                            <Tag color={newElement.isSuperAdmin ? "green" : "red"} className={"h-max-content ml-auto"}>{newElement.isSuperAdmin ? "Oui" : "Non"}</Tag>
                                        </div>
                                    }
                                </div>
                                {elementId && <div className="w-full">
                                    <span className="block text-gray-500 font-medium mb-1">Email validé</span>
                                    <div className={"flex gap-4"}>
                                        <Typography.Text>L'utilisateur a-t-il validé son email avec le code envoyé par mail ?</Typography.Text>
                                        <Tag color={newElement.isEmailValid ? "green" : "red"} className={`h-max-content ml-auto`}>{newElement.isEmailValid ? "Oui" : "Non"}</Tag>
                                    </div>
                                    {!newElement.isEmailValid && elementId !== "view" && <Button onClick={handleSendVerifyEmail} className={"rounded-lg mt-1"}>Renvoyer un mail de vérification</Button>}
                                </div>}
                            </div>
                        </form>
                    </div>
                    <div className="flex flex-col justify-between mt-6">
                        <div className={`flex ${elementId === "view" ? "justify-center" : "justify-between"} gap-2`}>
                            <Button icon={<CloseOutlined/>} className={"rounded-lg w-44"} onClick={() => {setIsOpen(false);resetForm();}}>
                                {elementId === "view" ? "Fermer" : "Annuler"}
                            </Button>
                            {elementId && elementId !== "view" && (
                                <Popconfirm
                                    title="Supprimer l'utilisateur"
                                    description="Êtes vous sur de vouloir le supprimer ?"
                                    okText="Oui"
                                    cancelText="Non"
                                    onConfirm={handleElementDelete}
                                >
                                    <Button icon={<DeleteOutlined/>} type="primary" danger={true} className={"rounded-lg w-44 mx-auto"}>
                                        Supprimer
                                    </Button>
                                </Popconfirm>
                            )}
                            {elementId && elementId !== "view" && isNewUser ? (
                                    <Popconfirm
                                        title="Valider l'utilisateur"
                                        description="Êtes-vous sûr de vouloir le valider ?"
                                        okText="Oui"
                                        cancelText="Non"
                                        onConfirm={handleElementSubmit}
                                    >
                                        <Button
                                            icon={<CheckOutlined/>}
                                            type="primary"
                                            className="rounded-lg w-44"
                                        >
                                            Valider
                                        </Button>
                                    </Popconfirm>
                                ) :
                                elementId && elementId !== "view" && !isNewUser ? (
                                    <Popconfirm
                                        title="Modifier l'utilisateur"
                                        description="Êtes-vous sûr de vouloir le modifier ?"
                                        okText="Oui"
                                        cancelText="Non"
                                        onConfirm={handleElementSubmit}
                                    >
                                        <Button
                                            icon={<EditOutlined />}
                                            type="primary"
                                            className="rounded-lg w-44"
                                        >
                                            Modifier
                                        </Button>
                                    </Popconfirm>
                                ) : elementId !== "view" ? (
                                    <Popconfirm
                                        title="Créér l'utilisateur"
                                        description="Êtes-vous sûr de vouloir le créér ?"
                                        okText="Oui"
                                        cancelText="Non"
                                        onConfirm={handleElementSubmit}
                                    >
                                        <Button
                                            icon={<PlusOutlined />}
                                            type="primary"
                                            className="rounded-lg w-44"
                                        >
                                            Créer
                                        </Button>
                                    </Popconfirm>
                                ) : null}
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
}